import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VContainer,[_c('Hero'),_c('Features'),_c('Why'),_c('Pricing')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }